import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customizer',
  templateUrl: './customizer.component.html',
  styleUrls: ['./customizer.component.less']
})
export class LayoutCustomizerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
